import { AType, EType, summon } from "@silversea-ssc/functional-support"
import { FareCode } from "@silversea-ssc/web-fares-fp"
import { CruiseCode, PositiveInt } from "@ssc-booking/functional-support"
import { Occupancy } from "../occupancy"
import { RealSuiteNumber } from "../suite-number"

export const Suite = summon((F) =>
    F.interface(
        {
            number: RealSuiteNumber(F),
            deck: PositiveInt(F),
            maxGuests: PositiveInt(F),
        },
        "Suite",
    ),
)
export type Suite = AType<typeof Suite>
export type SuiteEncoded = EType<typeof Suite>

export const AvailableSuitesResponse = summon((F) =>
    F.interface(
        {
            cruiseCode: CruiseCode(F),
            occupancy: Occupancy(F),
            fareCode: FareCode(F),
            suiteCategory: F.string(),
            suites: F.array(Suite(F)),
        },
        "AvailableSuitesResponse",
    ),
)
export type AvailableSuitesResponse = AType<typeof AvailableSuitesResponse>
export type AvailableSuitesResponseEncoded = EType<typeof AvailableSuitesResponse>
